"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Navigation = _interopRequireDefault(require("../../Navigation"));

var _HeaderUtility = require("./HeaderUtility.style");

var HeaderUtility = function HeaderUtility(_ref) {
  var links = _ref.links,
      userBtn = _ref.userBtn;
  return /*#__PURE__*/_react.default.createElement(_HeaderUtility.Wrapper, null, /*#__PURE__*/_react.default.createElement(_HeaderUtility.NavContainer, null, /*#__PURE__*/_react.default.createElement(_Navigation.default, {
    links: links,
    type: "utility",
    size: "small"
  }), userBtn && /*#__PURE__*/_react.default.createElement(_HeaderUtility.NavButton, Object.assign({
    variant: "link",
    size: "small",
    startIcon: "UserCircle",
    inverted: true
  }, userBtn), userBtn.label)));
};

HeaderUtility.propTypes = {
  links: _propTypes.default.arrayOf(Object),
  userBtn: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })
};
HeaderUtility.defaultProps = {
  links: [],
  userBtn: null
};
var _default = HeaderUtility;
exports.default = _default;